/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import config from '../../config';
import getEnv from '../../utils/env';
import router from '../../router';

const AmazonCognitoIdentity = require('amazon-cognito-identity-js');

const state = {
  userPool: [],
  authDetails: '',
  userData: '',
  cognitoUser: null,
  sessionToken: '',
  accessToken: '',
  idToken: '',
  idTokenExpirationDate: '',
  refreshToken: '',
  userId: null,
  username: '',
  errorCode: '',
  attributes: [],
  authenticated: false,
  tryAutoSignInFinished: false,
};

function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => {
        const str = `00${c.charCodeAt(0).toString(16)}`.slice(-2);
        return `%${str}`;
      })
      .join('')
  );
  return JSON.parse(jsonPayload);
}

const getters = {
  attributes(state) {
    return state.attributes;
  },
  authenticated(state) {
    return state.authenticated;
  },
  errorCode(state) {
    return state.errorCode;
  },
  idToken(state) {
    return state.idToken;
  },
  idTokenExpirationDate(state) {
    return state.idTokenExpirationDate;
  },
  userId(state) {
    return state.userId;
  },
  tryAutoSignInFinished(state) {
    return state.tryAutoSignInFinished;
  },
};

const mutations = {
  signOut(state) {
    if (state.cognitoUser) {
      state.cognitoUser.signOut();
    }
    state.sessionToken = null;
    state.accessToken = null;
    state.idToken = null;
    state.idTokenExpirationDate = null;
    state.refreshToken = null;
    state.authenticated = false;
    state.userId = null;
    state.username = '';
    state.userPool = [];
  },
  setAttributes(state, attributes) {
    state.attributes = attributes;
    state.username = state.attributes.filter((obj) => obj.Name === 'email')[0].Value;
  },
  setUsername(state, payload) {
    state.username = payload;
  },
  setTryAutoSignInFinished(state, payload) {
    state.tryAutoSignInFinished = payload;
  },
  signIn(state) {
    state.authenticated = true;
  },
  setUserPool(state) {
    state.userPool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData);
  },
  setTokens(state, payload) {
    state.accessToken = payload.getAccessToken().getJwtToken();
    state.idToken = payload.getIdToken().getJwtToken();
    state.idTokenExpirationDate = payload.getIdToken().getExpiration();
    state.refreshToken = payload.getRefreshToken().getToken();
  },
  setUserId(state, payload) {
    const jwt = payload.getIdToken().getJwtToken();
    const jwtContent = parseJwt(jwt);
    if (jwtContent['user-id']) {
      state.userId = jwtContent['user-id'];
    }
  },
  setCognitoUser(state, payload) {
    state.cognitoUser = payload;
  },
  setCognitoDetails(state, authData) {
    state.authDetails = new AmazonCognitoIdentity.AuthenticationDetails(
      authData
    );
    state.userData = { Username: authData.Username, Pool: state.userPool };
    state.cognitoUser = new AmazonCognitoIdentity.CognitoUser(state.userData);
  },
  setError(state, payload) {
    state.errorCode = payload;
  },
  clearError(state) {
    state.errorCode = '';
  },
};

const actions = {
  signIn({ state, commit, dispatch }, payload) {
    commit('clearError');
    commit('setUserPool');
    commit('setCognitoDetails', payload.authData);
    state.cognitoUser.authenticateUser(state.authDetails, {
      onSuccess: (result) => {
        commit('setTokens', result);
        commit('setUserId', result);
        commit('signIn');
        dispatch('getUserAttributes');
        dispatch('setLogoutTimer', getEnv('VUE_APP_COGNITO_SESSION_TIMEOUT'));
        router.push(payload.redirectRoute);
      },
      onFailure: (err) => {
        commit('setError', JSON.stringify(err.code));
      },
    });
  },
  tryAutoSignIn({ state, commit, dispatch }) {
    commit('setTryAutoSignInFinished', false);
    commit('setUserPool');
    const cognitoUser = state.userPool.getCurrentUser();
    if (cognitoUser != null) {
      commit('setCognitoUser', cognitoUser);
      state.cognitoUser.getSession((err, session) => {
        if (err) {
          // eslint-disable-next-line no-console
          console.error(JSON.stringify(err));
          commit('setTryAutoSignInFinished', true);
        } else {
          commit('setTokens', session);
          commit('setUserId', session);
          commit('signIn');
          dispatch('getUserAttributes');
          dispatch('setLogoutTimer', getEnv('VUE_APP_COGNITO_SESSION_TIMEOUT'));
          commit('setTryAutoSignInFinished', true);
        }
      });
    } else {
      commit('setTryAutoSignInFinished', true);
    }
  },
  getUserAttributes({ commit, dispatch }) {
    state.cognitoUser.getUserAttributes((err, attributes) => {
      if (err) {
        // eslint-disable-next-line no-console
        console.error(JSON.stringify(err));
      } else {
        commit('setAttributes', attributes);
      }
    });
  },
  setLogoutTimer({ state, commit, dispatch }, expirationTime) {
    setTimeout(() => {
      dispatch('signOut');
    }, expirationTime * 1000);
  },
  signOut({ commit }) {
    commit('signOut');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
